/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const newUserConfig = {
  FIELDS: [
    {
      type: 'email',
      compProps: {
        id: 'email',
        label: 'Email',
        required: true,
        readOnly: true,
        placeholder: 'Enter your email address',
        errorText: 'Email is required',
      },
    },
    {
      type: 'text',
      compProps: {
        id: 'firstName',
        label: 'First Name',
        required: true,
        placeholder: 'Enter your name',
        errorText: 'Name is required',
      },
    },
    {
      type: 'text',
      compProps: {
        id: 'lastName',
        label: 'Last Name',
        required: true,
        placeholder: 'Enter your name',
        errorText: 'Name is required',
      },
    },
    {
      type: 'checkBox',
      compProps: {
        id: 'termsOfUse',
        required: false,
        errorText: 'Invite user is required',
        direction: 'vertical',
        options: [
          {
            id: 'inviteUser',
            label: 'Invite User',
          },
        ],
      },
    },
  ],
  layout: [['email'], ['firstName'], ['lastName'], ['termsOfUse']],
};
